var EPK = EPK || {};

EPK.Remote = EPK.Remote || {};

$(function() {

	if (EPK.common.isSP) {
		// 特集バナースライダー
		EPK.Remote.spSpecialBannerSlide();
	} else {
		// 特集バナースライダー
		EPK.Remote.pcSpecialBannerSlide();
		// 近くの薬局スライダー
		EPK.Remote.pcNearShopsSlide();
	}

	if (EPK.common.action == 'index') {

		EPK.Remote.selectBoxEvent();

		//LPTOP診療科目から探すul調整
		var wrap = document.getElementById('subjectsWrap');
		if (wrap) {
			var subjectlistArr = document.querySelectorAll('ul.list-course-select li');
			EPK.Remote.ulHeight;

			//liが1行だけの時の最大の高さを取得しておく
			var subjectUl = document.querySelector('#subjectsWrap ul');
			// if (subjectUl) {
			// 	EPK.Remote.getUlHeight(subjectUl);

			// 	EPK.Remote.index = 0;
			// 	//診療科目から探す再描画
			// 	EPK.Remote.createUl(subjectlistArr,wrap,EPK.Remote.ulHeight,EPK.Remote.index);
			// }
		}
		//LPTOP診療科目から探すul調整 ここまで

	} else if (EPK.common.action == 'search') {

		//セレクトボックスイベント
		EPK.Remote.selectBoxEvent();

		//検索フォームイベント
		EPK.Remote.searchFormEvent();

		//診療科目の表示非表示
		EPK.Remote.subjectTextEvent();

		// 予約ボタン非同期
		EPK.Remote.asyncCheckReserveBtn();

		// オンライン診療費用非同期
		EPK.Remote.asyncHospitalFeeSearch();


	} else if (EPK.common.action == 'hospitalLp') {

		EPK.Remote.billboardSubjectEvent();

		// // 医師選択時診療時間枠要素非同期取得
		// EPK.Remote.doctorTimeFrame();
        //
		// // オンライン診療費用非同期
		// EPK.Remote.asyncHospitalFeeLp();

        // 予約ボタン非同期
        EPK.Remote.asyncCheckReserveBtn();

		/**
		 * 「閉じる」に表示が変更されたときに改行することがあるため
		 * 「閉じる」を初期値として改行位置を計算後、「開く」に戻す
		 */
		$('#subjects-open').removeAttr('checked');

	} else if (EPK.common.action == 'searchAga') {

		//#20143
		var redirectSort = function (position) {
			var tab = $('.sort a').data('tab');
			if (tab == 'normal') {
				if (EPK.common.latlng.lat && EPK.common.latlng.lng) {
					var href = $('.sort a').prop('href');
					href += (href.indexOf('?') !== -1 ? '&' : '?') + 'lat=' + EPK.common.latlng.lat + '&lng=' + EPK.common.latlng.lng + '&tab=distance';
					$('.sort a').prop('href', href);
					if (!EPK.Remote.isDistanceRedirect) {
						location.href = href + '&is_distance_redirect=1';
					}
				} else {
					$('.sort a').data('tab', 'normal').text('標準');
				}
			}
		}

		EPK.Remote.currentLocationSearch(redirectSort);
	}

	// 注意事項ポップアップ
    $(document).on("click",".js-fee-considerations",function() {
		var hospitalId   = $(this).data('hospital_id');
		var departmentId = $(this).data('department_id');

		if (!hospitalId || !departmentId) {
			return;
		}

		search_consideration_selector = '#' + hospitalId +'_' + departmentId;
		search_consideration_text     = $(search_consideration_selector).data("text");

		if (search_consideration_text.length == 0) {
			return;
		}

		search_consideration_text = search_consideration_text.replace(/\n/g,'<br>');
		$('.modal-bg').show();
		$('.modal-text').empty();
		$('.modal-text').append(search_consideration_text).trigger("create");
	});

	// 注意事項全表示
	$(document).on("click",".modal-close",function() {
		$('.modal-bg').hide();
	});

	// 注意事項全表示
    $(document).on("click",".js-considerations-open",function() {
		var departmentId = $(this).data('department_id');
		var cls_op = '.considerations-open-'+departmentId;
		var cls_cl = '.considerations-close-'+departmentId;
		$(cls_op).show();
		$(cls_cl).hide();
	});

	// 注意事項表示を戻す
    $(document).on("click",".js-considerations-close",function() {
		var departmentId = $(this).data('department_id');
		var cls_op = '.considerations-open-'+departmentId;
		var cls_cl = '.considerations-close-'+departmentId;
		$(cls_cl).show();
		$(cls_op).hide();
	});
});

/**
 * #12615 オンライン診療LP
 * 診療科目から探す liが一つの時のul最大値を取得
 * @method getUlHeight
 */
EPK.Remote.getUlHeight = function (ulArry) {
	var subjectulArr = document.querySelectorAll('#subjectsWrap ul');
	if (!ulArry) return;
	var heightArr = [];
	//liを一つ残して削除
	for (var i = 0; i < subjectulArr.length; i++) {
		var li = subjectulArr[i].querySelectorAll('li');
		for (var j = 0; j < li.length -1; j++) {
			li[j].parentNode.removeChild(li[j]);
		}
	}
	//ulの高さを取得
	subjectulArr = document.querySelectorAll('#subjectsWrap ul');
	for (var i = 0; i < subjectulArr.length; i++) {
		heightArr.push(subjectulArr[i].clientHeight);
	}
	if (heightArr.length > 0) {
		EPK.Remote.ulHeight = Number(Math.max.apply(null, heightArr));
	}
	//ul削除
	if (subjectulArr.length > 0) {
		for (var i = 0; i < subjectulArr.length; i++) {
			subjectulArr[i].parentNode.removeChild(subjectulArr[i]);
		}
	}
};

/**
 * #12615 オンライン診療LP
 * 診療科目から探す 再描画
 * @method createUl
 */
EPK.Remote.createUl = function (subjectlistArr,wrap,ulHeight,index) {
	var height = ulHeight;
	var createUl = function (subjectlistArr,wrap,ulHeight,index) {
			//ul再生成
		if (subjectlistArr.length > 0 && index < subjectlistArr.length) {

			var ulEl = document.createElement('ul');
			ulEl.className = 'list-course-select';
			//操作用の為indexでかぶらないようにする
			ulEl.id = 'addulEl-' + index;
			wrap.insertAdjacentElement('beforeend',ulEl);
			var addUl = document.getElementById('addulEl-' + index);

			for (var i = index; i < subjectlistArr.length; i++) {
				addUl.insertAdjacentElement('beforeend',subjectlistArr[i]);
				var addUlHeight = addUl.clientHeight;
				var addli = addUl.querySelectorAll('li');

				//新規ulの生成
				if ( addli.length == 1 && addUlHeight > height || addli.length == 4 && addUlHeight <= height) {
					//addUlが改行しない場合はliを4個まで入れる
					EPK.Remote.index = i + 1;
					EPK.Remote.createUl(subjectlistArr,wrap,ulHeight,EPK.Remote.index);
					break;
				} else if (addUlHeight > height) {
					//addUlHeightが大きくなった場合は改行したとみなし、追加したliを削除,indexを-1し自身を呼び出す
					subjectlistArr[i].parentNode.removeChild(subjectlistArr[i]);
					EPK.Remote.index = i;
					EPK.Remote.createUl(subjectlistArr,wrap,ulHeight,EPK.Remote.index);
					break;
				}
			}
		}
	}

	createUl(subjectlistArr,wrap,ulHeight,EPK.Remote.index);
	//クラスの付与
	var ulList = document.querySelectorAll('#subjectsWrap ul');
	if (ulList.length > 0) {
		for (var i = 0; i < ulList.length; i++) {
			var liList = ulList[i].querySelectorAll('li');
			if (liList.length = 0) return;
			ulList[i].classList.add('nth' + liList.length);
		}
	}

};

EPK.Remote.pcNearShopsSlide = function () {
	var nearShopsEl = document.getElementById('near_shops');
	var sliderEl = document.getElementById('near_shops_slide_contents');
	if (!nearShopsEl) {
		return;
	}
	if (sliderEl) {
		$('#near_shops_slide_contents').swiper({
			slidesPerView: 4,
			slidesPerColumn: 1,
			slidesPerGroup: 4,
			spaceBetween: 20,
			nextButton: ".swiper-button-next",
			prevButton: ".swiper-button-prev",
		});
		var slider = document.querySelectorAll('#near_shops li.swiper-slide');
		for (var i = 0; i < slider.length; i++) {
			slider[i].style.width = "";
		}
	}
}


EPK.Remote.pcSpecialBannerSlide = function () {
	var specialBnEl = document.getElementById('special_bn');
	var sliderEl = document.getElementById('special_slide_contents');
	if (!specialBnEl) {
		return;
	}
	if (sliderEl) {
		$('#special_slide_contents').swiper({
			slidesPerView: 3,
			slidesPerColumn: 1,
			slidesPerGroup: 3,
			spaceBetween: 24,
			nextButton: ".special-bn-next",
			prevButton: ".special-bn-prev",
			pagination: '.swiper-pagination',
			loop: true,
			autoplayDisableOnInteraction: false,
			autoplay: 5000,
		});
		var slider = document.querySelectorAll('#special_bn li.swiper-slide');
		for (var i = 0; i < slider.length; i++) {
			slider[i].style.width = "";
		}
	}
}


EPK.Remote.spSpecialBannerSlide = function () {
	var specialBnEl = document.getElementById('special_bn');
	var sliderEl = document.getElementById('special_slide_contents');
	if (!specialBnEl) {
		return;
	}
	if (sliderEl) {
		$('#special_slide_contents').swiper({
			freeMode: true,
			scrollbarHide: true,
			slidesPerView: 'auto',
			centeredSlides: true,
			grabCursor: true,
			loop: true,
			pagination: '.swiper-pagination',
		});
		var slider = document.querySelectorAll('#special_bn li.swiper-slide');
		for (var i = 0; i < slider.length; i++) {
			slider[i].style.width = "";
		}
	}
}


/**
 * #12615 オンライン診療LP　病院科目イベント
 * @method subjectTextEvent
 */
EPK.Remote.subjectTextEvent = function () {
	var subjects = document.querySelectorAll('ul.subjects-list');
	var divHeight;
	if (subjects.length > 0) {
		//科目が一つの時の高さを取得する
		for (var i = 0; i < subjects.length; i++) {
			var subject = subjects[i].querySelectorAll('li.js-subject');
			if (subject.length > 0) {
				divHeight = subjects[i].clientHeight;

				//科目の描画
				//最初の一つを表示しそれ以外は改行していたら表示しない
				var $is_over = false;
				for (var j = 0; j < subject.length; j++) {
					if(j == 0){
						subject[j].style.display = '';
						continue;
					}
					if(6 <= j){
						subject[j].style.display = 'none';
						continue;
					}
					if($is_over){
						// 既に改行対象だった場合
						subject[j].style.display = 'none';
					}
					// list内spanタグの高さがulを超過した場合そこで終了
					subject[j].style.display = '';
					var height = subject[j-1].firstChild.offsetHeight;
					console.log(height)
					if (divHeight < height) {
						if (j === 0) {
							break;
						} else {
							$is_over = true;
							subject[j].style.display = 'none';
							continue;
						}
					}
				}
			}
		}

		//非表示科目カウント
		for (var i = 0; i < subjects.length; i++) {
			var count = 0;
			var subjectArr = subjects[i].querySelectorAll('li.js-subject');
			var hideSubjectsCount = subjects[i].querySelector('.puls');
			for (var j = 0; j < subjectArr.length; j++) {
				if (subjectArr[j].style.display == 'none') {
					count++
				}
			}
			if (count == 0) {
				hideSubjectsCount.style.display = 'none'
			} else {
				hideSubjectsCount.querySelector('span').innerHTML = '+'+count;
			}
		}
	}
};

/**
 * #12615 オンライン診療LP　セレクトボックスイベント
 * @method selectBoxEvent
 */
EPK.Remote.selectBoxEvent = function () {
	EPK.Remote.$selectPref = $('[name=pref_id]');
	EPK.Remote.$selectMajorDepartment = $('[name=major_department_id]');
	EPK.Remote.$searchBtn = $('#search_btn');

	EPK.Remote.selectedPrefId = '00';
	EPK.Remote.selectedMajorDepartmentId = '00';

	var addGAClass = function() {
		var GA = 'GA_lp_remotesearch_list_' + EPK.Remote.selectedPrefId + '_' + EPK.Remote.selectedMajorDepartmentId + '_searchbtn';
		EPK.Remote.$searchBtn.removeClass(function(index, className) {
			var removeClassName = 'GA_lp_remotesearch_list';
			var reg = RegExp('\\b' + removeClassName + '\\S+', 'g');

			return (className.match(reg) || []).join(' ');
		});
		EPK.Remote.$searchBtn.addClass(GA);
	}

	var prefId = EPK.Remote.$selectPref.val();
	var subjectId = EPK.Remote.$selectMajorDepartment.val();
	if (prefId != 0) {
		EPK.Remote.$selectPref.addClass('select-active');
		// GA
		EPK.Remote.selectedPrefId = prefId != 0 ? ('0'+prefId).slice(-2) : '00';
	}
	if (subjectId) {
		EPK.Remote.$selectMajorDepartment.addClass('select-active');
		// GA
		if (subjectId) {
			if (subjectId.length > 2) {
				EPK.Remote.selectedMajorDepartmentId = subjectId;
			} else {
				EPK.Remote.selectedMajorDepartmentId = ('0'+subjectId).slice(-2);
			}
		} else {
			EPK.Remote.selectedMajorDepartmentId = '00';
		}
	}
	addGAClass();

	EPK.Remote.$selectPref.on('change', function(event) {
		var optionsElements = '';
		prefId = $(this).val();
		if (prefId != 0) {
			$.each(EPK.Remote.selectOptionsMajorDepartment[prefId], function(majorDepartmentId, label) {
				optionsElements += '<option value="'+majorDepartmentId+'">'+label+'</option>';
			});
			EPK.Remote.$selectPref.addClass('select-active');
			if (EPK.Remote.$selectMajorDepartment.hasClass('select-active')) {
				EPK.Remote.$selectMajorDepartment.removeClass('select-active');
			}
		} else {
			optionsElements = '<option value="0">診療科目を選ぶ</option>';
			$.each(EPK.Remote.selectOptionsMajorDepartmentAll, function(majorDepartmentId, label) {
				optionsElements += '<option value="'+majorDepartmentId+'">'+label+'</option>';
			});
			if (EPK.Remote.$selectPref.hasClass('select-active')) {
				EPK.Remote.$selectPref.removeClass('select-active');
			}
			if (EPK.Remote.$selectMajorDepartment.hasClass('select-active')) {
				EPK.Remote.$selectMajorDepartment.removeClass('select-active');
			}
		}

		EPK.Remote.$selectMajorDepartment.find('option').remove();
		EPK.Remote.$selectMajorDepartment.append(optionsElements);

		// GA
		EPK.Remote.selectedPrefId = prefId != 0 ? ('0'+prefId).slice(-2) : '00';
		EPK.Remote.selectedMajorDepartmentId = '00';
		addGAClass();
	});

	EPK.Remote.$selectMajorDepartment.on('change',function () {
		var subjectval = $(this).val();
		if (subjectval != 0) {
			EPK.Remote.$selectMajorDepartment.addClass('select-active');
		} else {
			if (EPK.Remote.$selectMajorDepartment.hasClass('select-active')) {
				EPK.Remote.$selectMajorDepartment.removeClass('select-active');
			}
		}

		// GA
		if (subjectval != 0) {
			if (subjectval.length > 2) {
				EPK.Remote.selectedMajorDepartmentId = subjectval;
			} else {
				EPK.Remote.selectedMajorDepartmentId = ('0'+subjectval).slice(-2);
			}
		} else {
			EPK.Remote.selectedMajorDepartmentId = '00';
		}
		addGAClass();
	})

	EPK.Remote.$searchBtn.on('click', function(event) {
		// url
		var url = $(this).data('url');

		// pref_id
		var prefId = EPK.Remote.$selectPref.val();
		if (prefId && parseInt(prefId) && EPK.Remote.selectOptionsPrefFuri && EPK.Remote.selectOptionsPrefFuri[prefId]) {
			url += '/' + EPK.Remote.selectOptionsPrefFuri[prefId];
		}

		// major_department_id
		var majorDepartmentId = EPK.Remote.$selectMajorDepartment.val();
		if (majorDepartmentId && parseInt(majorDepartmentId)) {
			if (url == $(this).data('url')) {
				url += '/s';
			}
			url += '/' + majorDepartmentId;
		}

		location.href = url;
	});
}

/**
 * オンライン診療LP　検索フォームイベント
 * @method searchFormEvent
 */
EPK.Remote.searchFormEvent = function () {
	console.log("searchForm")
}

/**
 * #12615 オンライン診療LP　病院LP画面TOP科目表示非表示
 * @method lpTopSubjectShow
 */
EPK.Remote.billboardSubjectEvent = function () {
	var subject = document.querySelector('.subjects');
	var openSubject = document.querySelector('.subjects-all');
	var subjectArr,divHeight,height;
	if (!subject) return;
	subjectArr = subject.querySelectorAll('.subjects > span');
	if (subjectArr.length > 0) {
		//科目がない時の高さを取得する（開くのみ）
		for (var i = 0; i < subjectArr.length ; i++) {
			subjectArr[i].style.display = 'none';
		}
		subject = document.querySelector('.subjects');
		divHeight = subject.clientHeight;

		//非表示にした科目を表示していき改行したら閉じるに移動
		for (var i = 0; i < subjectArr.length ; i++) {
			if (i == 0) {
				subjectArr[i].style.display = '';
			} else {
				subjectArr[i].style.display = '';
				height = subjectArr[i].parentNode.clientHeight;
				if (divHeight < height) {
					openSubject.insertAdjacentElement('afterbegin',subjectArr[i]);
				}
			}
		}

		//開く内に科目が無かったら開く非表示
		var open = document.getElementById('subjects-open');
		var openLabel = document.querySelector('label[for="subjects-open"]');
		var hideSubject = openSubject.querySelectorAll('span');
		if (hideSubject.length == 0) {
			open.style.display = 'none';
			openLabel.style.display = 'none';
		}
	}
}

/**
 * @method doctorTimeFrame
 */
EPK.Remote.doctorTimeFrame = function() {

	// 初診可否フラグ更新
	var updateReserveIcon = function (hospitalDepartmentId, doctorId) {
		var iconWrapElem = $('.icon-wrap[data-hospital-department-id=' + hospitalDepartmentId + ']');
		iconWrapElem.empty();
		if (doctorList[hospitalDepartmentId][doctorId]['enabled_composite_first_visit']) {
			iconWrapElem.append('<span class="icon beginner">初診OK</span>');
		} else {
			iconWrapElem.append('<span class="icon return">再診のみ</span>');
		}
	};

	// 診療時間カレンダー更新
	var updateReserveHourTable = function (hospitalDepartmentId, schedule) {
		var hourTableElem = $('table.hour-table[data-hospital-department-id=' + hospitalDepartmentId + '] tbody');
		var headerElem = hourTableElem.find('tr:first');
		hourTableElem.empty();
		hourTableElem.append(headerElem);
		$.each(schedule, function (time, statuses) {
			var trElem = $("<tr></tr>");
			trElem.append($("<td></td>").html(time));
			$.each(statuses, function (index, status) {
				trElem.append($("<td></td>").html(status));
			});

			hourTableElem.append(trElem);
		});
	};

	// オンライン診療予約ボタン更新
	var updateRserveBtn = function (hospitalDepartmentId, doctorId) {
		// 非同期処理中はローダを表示する
		var target = $('.button-subscribe[data-hospital-department-id=' + hospitalDepartmentId + ']');
		target.find('a')
			.html('')
			.addClass('disabled')
			.append('<img src="' + loaderImgPath +'" alt="" width="40" height="40" />');


		// AGA対応
		var agaFlag = 0;

		// 外来診療
		var outpatientFlag = 0;
		var checkHospitalDepartmentId = String(hospitalDepartmentId);
		if (checkHospitalDepartmentId.slice(0, 10) == '9999999999') {
			checkHospitalDepartmentId = checkHospitalDepartmentId.slice(10);
			outpatientFlag = 1;
		}

		// 非同期で予約枠の空きを確認する
		var viewBtnCount = target.data('view-btn-count');
		$.ajax({
			type: 'GET',
			dataType: 'HTML',
			url: '/api/hospital/department/update_reserve_btn',
			data: {
				hospitalId: hospitalId,
				hospitalDepartmentId: checkHospitalDepartmentId,
				doctorId: doctorId,
				viewBtnCount: viewBtnCount,
				outpatientFlag: outpatientFlag,
				agaFlag: agaFlag,
			},
			timeout: 20000,
			cache: false
		})
		.done(function(html) {
			// ボタンを更新する
			target.empty();
			target.append(html);


			if (outpatientFlag) {
				var tempElem = $('.outpatient_enabled_first_visit');
				var iconWrapElem = $('.icon-wrap[data-hospital-department-id=' + hospitalDepartmentId + ']');
				iconWrapElem.empty();
				if (tempElem.length > 0) {
					iconWrapElem.append('<span class="icon beginner">初診OK</span>');
				} else {
					iconWrapElem.append('<span class="icon return">再診のみ</span>');
				}
				tempElem.remove();
			}
		});
	};

	// 選択中・表示中の医師名更新
	var updateDoctor = function (hospitalDepartmentId, doctorId) {
		var doctor = doctorList[hospitalDepartmentId][doctorId];

		// 医師選択ボックスのselected属性を更新（PC版は左右のボックスで値を同期させるため）
		var doctorSelectElem = $('.list-treatment-menu select[name=doctor][data-hospital-department-id=' + hospitalDepartmentId + ']');
		doctorSelectElem.find('option:selected').prop('selected', false);
		doctorSelectElem.find('option[value=' + doctorId + ']').prop('selected', true);

		// 診療科名の横に表示する医師名の更新
		var fullname = doctor['last_name'] + doctor['first_name'];
		var doctorNameElem = $('.doctor-name[data-hospital-department-id=' + hospitalDepartmentId + ']');
		doctorNameElem.empty();
		doctorNameElem.html('担当医：' + fullname + '先生');
	};

	// 診療メニュー更新
	var updateTreatmentMenu = function (hospitalDepartmentId, doctorId) {
		// 営業時間情報取得
		var scheduleList = opentimeList[hospitalDepartmentId];
		var schedule = scheduleList[doctorId];

		// 初診可否フラグ更新
		updateReserveIcon(hospitalDepartmentId, doctorId);

		// 診療時間カレンダー更新
		updateReserveHourTable(hospitalDepartmentId, schedule);

		// 予約ボタンの更新
		updateRserveBtn(hospitalDepartmentId, doctorId);

		// 選択中医師の更新
		updateDoctor(hospitalDepartmentId, doctorId);
	};

	// ロード直後の処理
	$(".button-subscribe a.no-doctor").each(function(index, element){
		// 予約ボタンの更新
		var hospitalDepartmentId = $(element).parent().data('hospital-department-id');
		updateRserveBtn(hospitalDepartmentId);
	});
	$(".list-treatment-menu select").each(function(index, element){
		var isMainSelector = $(element).parent().parent().hasClass('main');
		if (!isMainSelector) {
			return true;
		}

		// 選択肢1件目の医師ID
		var doctorId = $(element).find('option').first().val();
		// 診療科ID
		var hospitalDepartmentId = $(element).data('hospital-department-id');

		updateTreatmentMenu(hospitalDepartmentId, doctorId);
	});
	/**
	 * ネット決済のpopup
	 * refs: plugins/Mobile/webroot/js/dist/controllers/remote_shoho.js
	 * refs: webroot/css/shoho.css
	 */
	$('#credit-popup').on('click', function() {
		$(this).toggleClass('is-active');
	});
	$('#cradit-popup-close').on('click',function () {
		if ($('#credit-popup').hasClass('is-active')) {
			$('#credit-popup').removeClass('is-active')
		}
	});

	// 医師選択時の処理
	$('.list-treatment-menu select').on('change', function() {
		// 医師ID
		var doctorId = $(this).val();
		// 診療科ID
		var hospitalDepartmentId = $(this).data('hospital-department-id');

		updateTreatmentMenu(hospitalDepartmentId, doctorId);
	});
}

/**
 * 病院検索ページの予約ボタン非同期処理
 * @method asyncCheckReserveBtn
 */
EPK.Remote.asyncCheckReserveBtn = function () {
	var departmentIdList = [];
    const is_search_page = (EPK.common.action == 'search');
    const makeBtnText = function (reserve_kbn , a_tag){
        if(reserve_kbn == 2){
            if(is_search_page){
                a_tag.html('<p>通院の予約はこちら</p>');
            }else {
                a_tag.text('通院の予約はこちら');
            }
        }else{
            if(is_search_page){
                a_tag.html('<p>オンライン診療の<br>予約はこちら</p>');
            }else{
                a_tag.html('オンライン診療の<br>予約はこちら');
            }
        }
    }

	$.each($('.reserve-btn , .btnbox'), function(key, val) {
		var hospitalId = $(val).data('hospital_id');
		var departmentId = $(val).data('department_id');
		if (hospitalId && departmentId) {
			departmentIdList = [];
			departmentIdList.push({
				'hospitalId': hospitalId,
				'departmentId': departmentId
			});

			$.ajax({
				type: 'GET',
				dataType: 'JSON',
				url: '/api/hospital/search/check_reserve_btn',
				data: {
					hospitalDepartmentIdList: departmentIdList
				},
				cache: false
			})
			.done(function(data) {
                if (data) {
                    $.each($('.reserve-btn , .btnbox'), function(key, val) {
                        var _departmentId = $(val).data('department_id');
                        var free_medical_kbn = $(val).data('free_medical_kbn');
                        var reserve_kbn = $(val).data('reserve_kbn');
                        var a_tag = $(val).find('a');
                        if (departmentId == _departmentId) {
                            if (!data[_departmentId]) {
                                a_tag.addClass('is-disabled');
                                _href = 'javascript:void(0);';
                                a_tag.prop('href',_href);
                            }else{
                                a_tag.removeClass('is-disabled');
                                _href = "/remote/"+free_medical_kbn+"/select?department_id="+_departmentId;
                                a_tag.prop('href',_href);
                                makeBtnText(reserve_kbn , a_tag);
                            }

                        }
                    });
                }
			})
			.fail(function(a,b,c) {
				console.log(a);
				console.log(b);
				console.log(c);
			});
		}
	});
}

/**
 * オンライン診療費用非同期処理(一覧画面)
 * @method asyncHospitalFee
 */
EPK.Remote.asyncHospitalFeeSearch = function () {
	var calledHospitalList = [];

	$.each($('.js-hospitalfee'), function(key, val) {
		var hospitalId = $(val).data('hospital_id');

		var calledHospitalResult = $.inArray(hospitalId, calledHospitalList);

		if (hospitalId && calledHospitalResult == -1) {
			calledHospitalList.push(hospitalId);

			$.ajax({
				type: 'GET',
				dataType: 'JSON',
				url: '/api/hospital/search/hospital_fee',
				data: {
					hospital_id:hospitalId
				},
				timeout: 20000,
				cache: false
			})
			.done(function(getFeeList) {
				if (getFeeList) {
					$.each($('.js-hospitalfee'), function(key, val) {
						var textElem = '';
						var feeText = '';
						var feeInclusionText = '';
						var considerationstext = '';
						var _hospitalId = $(val).data('hospital_id');
						var _departmentId = $(val).data('department_id');
						var _actionMode = $(val).data('action_mode');

						var data = '';
						$.each(getFeeList, function(index, tmpFee) {
							var get_fee_hospital_department_id = tmpFee['hospital_department_id'];
							if (_departmentId == get_fee_hospital_department_id) {
								data = tmpFee;
							}
						})

						if (data != '') {
							if (_actionMode == 1) {
								// 自由診療
								feeText = '<dt>' + '料金：' + '<span>お薬代のみ</span>' + '</dt>';
								$(val).empty();
								$(val).append(feeText).trigger("create");
							} else {
								// 料金
								if (data.fee_flg == 0) {
									feeText = '<dt>' + '料金：' + '<span>診療費用のみ</span>' + '</dt>';
								} else {
									if (data.yen_display_type == 1) {
										_yen_display_type = '円（税込）';
									} else if(data.yen_display_type == 2) {
										_yen_display_type = '円（税込）～';
									}
									feeText = '<dt>' + '料金：<span>' + Number(data.total_fee).toLocaleString() +  _yen_display_type + '</span></dt>';

									if (data.fee_flg == 1 && data.medical_fee_inclusion_flg == 1) {

										feeInclusionText = '※診察に関連する費用を含みます</br>';
									}
								}

								// 注意事項
								if (data.considerations_display_flg == 1) {
									_considerations = data.considerations.replace(/\n/g,'<br>');
									_considerations = '<span id="' + _hospitalId +'_' + _departmentId + '">' +  _considerations + '</span>';
									_considerations = _considerations + '<a class="js-fee-considerations" href="javascript:void(0);" data-hospital_id="'+ _hospitalId +'" data-department_id="' + _departmentId + '" style="display:none"><span>...</span>続きを見る</a>';
									considerationstext = '<span class="notes-text">【注意事項】' + _considerations + '</span>' ;
								}

								if(feeInclusionText.length > 0 || considerationstext.length > 0) {
									textElem =  feeText + '<dd>' + feeInclusionText + considerationstext + '</dd>';
								} else {
									textElem =  feeText;
								}

								$(val).empty();
								$(val).append(textElem).trigger("create");

								// 構築後一定以上の高さでPOPUPJS表示
								considerationsHeightSelector = 'span#' + _hospitalId + '_' + _departmentId + '';
								considerationsHeight         = $(considerationsHeightSelector).outerHeight();
								if (considerationsHeight > 45) {
									$(considerationsHeightSelector).next('a').show();
								}
								$(considerationsHeightSelector).parent().parent().addClass('fixed');

							}
						}
					});
				}
			})
			.fail(function(a,b,c) {

			});

		}
	});
}

/**
 * オンライン診療費用非同期処理(詳細画面)
 * @method asyncHospitalFeeLp
 */

EPK.Remote.asyncHospitalFeeLp = function () {
	var calledHospitalList = [];

	$.each($('.js-hospital_lp_fee'), function(key, val) {
		var hospitalId = $(val).data('hospital_id');

		var calledHospitalResult = $.inArray(hospitalId, calledHospitalList);

		if (hospitalId && calledHospitalResult == -1) {
			calledHospitalList.push(hospitalId);

			$.ajax({
				type: 'GET',
				dataType: 'JSON',
				url: '/api/hospital/search/hospital_fee',
				data: {
					hospital_id:hospitalId
				},
				cache: false
			})
			.done(function(getFeeList) {
				if (getFeeList) {
					$.each($('.js-hospital_lp_fee'), function(key, val) {

						var textElem = '';

						var feeText = '';
						var _departmentId = $(val).data('department_id');
						var _actionMode   = $(val).data('action_mode');
						var heightMax = 39;

						var data = '';
						$.each(getFeeList, function(index, tmpFee) {
							var get_fee_hospital_department_id = tmpFee['hospital_department_id'];
							if (_departmentId == get_fee_hospital_department_id) {
								data = tmpFee;
							}
						})

						if (data != '') {
							if (_actionMode == 1) {
								// 自由診療
								feeText = '<dl><dt>料金</dt><dd>お薬代のみ';
								$(val).empty();
								$(val).append(feeText).trigger("create");
							} else {
								// 料金
								if (data.fee_flg == 0) {
									textElem = '<dl><dt>料金</dt><dd>診療費用のみ';
								} else {
									if (data.yen_display_type == 1) {
										_yen_display_type = '円（税込）';
									} else if(data.yen_display_type == 2) {
										_yen_display_type = '円（税込）～';
									}
									textElem = '<dl><dt>料金</dt><dd>' + Number(data.total_fee).toLocaleString() +  _yen_display_type;

									if ( data.fee_flg == 1 && data.medical_fee_inclusion_flg == 1) {
										textElem += '<span class="sub">※診察に関連する費用を含みます' + '</span>';
										heightMax = 58.5;
									}

									// 料金詳細
									var _detail = [];
									if (data.m_hospital_department_fee_detail.length > 0) {
										data.m_hospital_department_fee_detail.forEach(function(value,key){
											var _detail_fee = '';
											var _detail_yen_display_type = '';
											var _detail_display_name = '';

											if (value.display_flg == 1) {

													_detail_fee = value.fee;

													if (value.yen_display_type == 1) {
														_detail_yen_display_type = '円';
													} else if(value.yen_display_type == 2) {
														_detail_yen_display_type = '円～';
													}

													_detail_display_name = value.display_name;

													_detail.push('・' + Number(_detail_fee).toLocaleString() + _detail_yen_display_type + '（' + _detail_display_name + '）');

											}

										});
										if(_detail.length>0) {
											textElem += '<div class="price-detail">' +
											'<input id="price_detail_' + _departmentId + '" type="checkbox">' +
											'<label for="price_detail_' + _departmentId + '">料金詳細をみる</label>' +
											'<div class="txt">' + _detail.join('<br />') + '</div></div>';
										}

									}
								}

								// 注意事項
								if (data.considerations_display_flg == 1) {
									_considerations = data.considerations.replace(/\n/g,'<br>');
									textElem +=
									'<div class="notes">' +
										'<input type="checkbox" id="notes_' + _departmentId + '">'+
											'<div class="txt">' +
												'<p><span>【注意事項】' + _considerations + '</span></p>' +
											'</div>' +
										'<label for="notes_' + _departmentId + '" class="view">続きを読む</label>' +
										'<label for="notes_' + _departmentId + '" class="close">閉じる</label>' +
									'</div>';
								}

								textElem += '</dd></dl>';
								$(val).empty();
								$(val).append(textElem).trigger("create");

								textHeight =  $('.considerations-open-' + _departmentId).outerHeight();
								if (textHeight <= 65) {
									$('.considerations-open-' + _departmentId).hide();
								}
								// $('.considerations-open-' + _departmentId).hide();
							}
						}

					});
					//「…もっと読む」ボタンの表示切替
					$('.list-treatment-menu').each(function() {
						var $text = $(this).find('.salestime-price ul li dl dd .notes .txt span');//対象のテキスト
						var $more = $(this).find('.salestime-price ul li dl dd .notes label');//続きを読むボタン
						var $elipsis = $(this).find('.salestime-price ul li dl dd .notes .txt p');
						var lineNum = 2;//表示する行数
						var textHeight = $text.height();//テキスト全文の高さ
						var lineHeight = parseFloat($text.css('line-height'));//line-height
						var textNewHeight = lineHeight * lineNum;//指定した行数までのテキストの高さ

						// テキストが表示制限の行数を超えたら発動
						if (textHeight > textNewHeight) {
						  $text.css({
							height: textNewHeight,
							overflow: 'hidden',
						  });

						} else {
						  // 指定した行数以下のテキストなら続きを読むは表示しない
						  $more.hide();
						  $elipsis.addClass('none');
						}
					});
				}
			})
			.fail(function(a,b,c) {
			});
		}
	});
}

/**
 * @method EPK.Remote.currentLocationSearch
 */
EPK.Remote.currentLocationSearch = function (callback) {

	var showError=true;
	var errorInfo = [
		"原因不明のエラーが発生しました。\n圏外でない場合は、端末の位置情報サービスの設定が有効になっているかご確認ください。",
		"位置情報が正しく計測されませんでした。\n圏外でない場合は、端末の位置情報サービスの設定が有効になっているかご確認ください。",
		"電波状況などで位置情報が取得できませんでした。電波状況のいいところで再度お試しください。",
		"位置情報の取得に時間がかかり過ぎてタイムアウトしました。電波状況のいいところで再度お試しください。"
	];

	var showAlertErrorMessage = function(){
		// エラーメッセージ
		var errorMessage = errorInfo[EPK.currentPlace.errorNo];

		// アラート表示
		var Browser = getBrowser();
		if (EPK.common.isSP ) {

			if (window.isiOS) {
				if ((EPK.currentPlace.errorNo == '1' || EPK.currentPlace.errorNo == '2') && Browser == 'Safari'){
					if (iosCheck()) { //iOS14以上は案内を表示
						errorMessage = errorMessage + "\n\n設定 > safari > 場所 の順に選択し\nkusurinomadoguchi.comを許可に変更の上、再読み込み後もう一度お試しください。";
						alert(errorMessage);
					} else {
						alert(errorMessage);
					}
				} else {
					alert(errorMessage);
				}
			} else {
				if ((EPK.currentPlace.errorNo == '1' || EPK.currentPlace.errorNo == '2') && Browser == 'Chrome'){
					errorMessage = errorMessage + "\n\nchromeのアドレスバー右のメニューから\n設定 > サイトの設定 > 位置情報 \nの順に選択しブロック中リストのくすりの窓口サイトの設定を許可へ変更しもう一度お試しください。"
					alert(errorMessage);
				} else {
					alert(errorMessage);
				}
			}
		} else {
			alert(errorMessage);
		}
	};

	var getBrowser = function () {
		var userAgent = window.navigator.userAgent.toLowerCase();
		if(userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {
			return 'IE';
		} else if(userAgent.indexOf('edge') != -1 || userAgent.indexOf('edga') != -1) {
			return 'Edge';
		} else if(userAgent.indexOf('samsungbrowser') != -1){
			return 'Samsung';
		} else if(userAgent.indexOf('chrome') != -1) {
			return 'Chrome';
		} else if(userAgent.indexOf('safari') != -1) {
			if (userAgent.indexOf('crios') != -1) {
				return 'Chrome';
			} else {
				return 'Safari';
			}
		} else if(userAgent.indexOf('firefox') != -1) {
			return 'FireFox';
		} else if(userAgent.indexOf('opera') != -1) {
			return 'Opera';
		} else {
			return'other';
		}
	};

	var iosCheck = function () {
		var userAgent = window.navigator.userAgent.toLowerCase();
		if(/iphone/.test(userAgent)) {
			userAgent.match(/iphone os (\w+){1,3}/g);
			var iosver =(RegExp.$1.replace(/_/g, '')).slice(0,3);
			if(iosver >= 140) {
				//iPhone iOS14 以上
				return true;
			} else {
				//iPhone iOS14 以下
				return false;
			}
		}
	};

	var errorHandler = function(error) {
		// エラーコード(error.code)の番号
		// 0:UNKNOWN_ERROR				原因不明のエラー
		// 1:PERMISSION_DENIED			利用者が位置情報の取得を許可しなかった
		// 2:POSITION_UNAVAILABLE		電波状況などで位置情報が取得できなかった
		// 3:TIMEOUT					位置情報の取得に時間がかかり過ぎた…

		// エラー番号
		var errorNo = error.code;
		var inOneMinutes = new Date(new Date().getTime() + 1 * 60 * 1000);
		Cookies.set('errorNo', errorNo, { expires: inOneMinutes} );
		EPK.currentPlace.errorNo = errorNo;
		if(!showError){
			console.log('現在位置が取得できませんでした。');
			console.log(errorInfo[errorNo]);
			console.log('errorNo:' + errorNo);
			return;
		}
		console.error(error);
		showAlertErrorMessage();
	};

	var getCurrentPlace = function(callback, argShowError, argUseCookie){

		// エラー表示の切り替え
		// グローバル変数: showError に情報隔離
		if(argShowError != null){
			showError = argShowError;
		}

		if(typeof argUseCookie == "undefined") {
			argUseCookie = true
		}

		if(argUseCookie){
			var tmpLat = Cookies.get('lat');
			var tmpLng = Cookies.get('lng');
			var tmpErrNo = Cookies.get('errorNo');
			if(tmpLat && tmpLng) {
				EPK.common.latlng.lat = tmpLat*1.0;
				EPK.common.latlng.lng = tmpLng*1.0;
				return;
			}
			if(tmpErrNo){
				EPK.currentPlace.errorNo = tmpErrNo;
			}
		}

		// ユーザーの端末がGeoLocation APIに対応しているかの判定
		// 対応している場合
		if (navigator.geolocation) {
			// 現在地を取得
			navigator.geolocation.getCurrentPosition(
				// [第1引数] 取得に成功した場合の関数
				function(position){
					var data = position.coords ;
					var lat = data.latitude;
					var lng = data.longitude;

					EPK.common.latlng.lat = lat;
					EPK.common.latlng.lng = lng;

					callback(position);
				},
				// [第2引数] 取得に失敗した場合の関数
				errorHandler.bind(this),

				// [第3引数] オプション
				{
					"enableHighAccuracy": false,
					"timeout": 8000,
					"maximumAge": 2000,
				}
			);
		} // 対応していない場合
		else if(showError) {
			// エラーメッセージ
			var errorMessage = "現在地情報を取得できませんでした。<br>端末の設定より現在地情報サービスをオンにして下さい。";

			// アラート表示
			alert(errorMessage);
		}
	};

	getCurrentPlace(callback, true, false);

}
